import { useEffect, useRef } from "react";

const hootSoundUrl = "https://swivl-cdn.s3-us-west-1.amazonaws.com/sounds/notification-hoot-5-secs-silence.mp3";

export function useEscalationSound(shouldPlay: boolean) {
  const audioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    if (!audioRef.current) {
      const audio = new Audio(hootSoundUrl);
      audio.loop = true; // loop the sound
      audio.preload = "auto"; // preload the audio
      audioRef.current = audio;
    }

    const audio = audioRef.current;

    if (!audio) {
      return;
    }

    if (shouldPlay) {
      audio.currentTime = 0; // rewind to start

      audio.play().catch((err) => {
        console.warn("Audio - play blocked/failed", {
          err,
          vis: document.visibilityState,
          muted: audio?.muted,
          hidden: document.hidden,
          readyState: audio?.readyState,
          volume: audio?.volume
        });
      });
    } else {
      if (!audio.paused) {
        audio.pause();
        audio.currentTime = 0;
      }
    }

    return () => {
      audio.pause();
    };
  }, [shouldPlay]);
}
